import { NAO_CONFORMIDADES_FORNECEDORES_EXTENSION, generalObjectBuilder, genericDelete, genericPost, genericUpdate } from "../../../services/api.service";
import TableView from "../../Common/TableView";
import { NaoConformidadesFornecedoresConfig } from "./NaoConformidadesFornecedores.config";




export function NaoConformidadesFornecedor() {


    return (<div>
        <TableView
            title={"Não conformidades Fornecedores"}

            postEntity={genericPost(NAO_CONFORMIDADES_FORNECEDORES_EXTENSION)}
            editEntity={genericUpdate(NAO_CONFORMIDADES_FORNECEDORES_EXTENSION)}
            deleteEntity={genericDelete(NAO_CONFORMIDADES_FORNECEDORES_EXTENSION)}
            tableConfigs={NaoConformidadesFornecedoresConfig}
            dataBuildFunction={generalObjectBuilder(NaoConformidadesFornecedoresConfig)}
            entityName={"Não conformidade Forncecedor"}
            idProp={"code"}
            reroute={true}
            configMapKey={"nao-conformidades-fornecedores"}
        />
    </div>)



}